<template>
  <div class="wrapper-map mb-4">
    <div id="map" class="order-2 order-md-1 mt-1 mt-md-0" />
    <div class="wrapper-filtros position-absolute order-1 order-md-2">
      <ul class="pl-0 mb-0 min-w-280 w-25 row no-gutters mx-md-0">
        <li class="col-12 col-sm-6 col-md-12 px-2 px-md-0 d-flex align-items-center mb-1">
          <div :class="{ active: verTransporte === true }" class="checkbox bg-white w-100 py-2 px-3 rounded shadow">
            <label class="d-flex align-items-center mb-0">
              <div class="p-sm font-AR f-14 w-100 d-flex align-items-center mb-0">
                Ciclovias
              </div>
              <input v-model="verTransporte" class="check" type="checkbox" @change="checkTransporte()">
            </label>
          </div>
        </li>
        <li class="col-12 col-sm-6 col-md-12 px-2 px-md-0 d-flex align-items-center mb-1">
          <div :class="{ active: verEstacionesSubte === true }"
            class="checkbox bg-white w-100 py-2 px-3 rounded shadow">
            <label class="d-flex align-items-center mb-0">
              <div class="p-sm font-AR f-14 w-100 d-flex align-items-center mb-0">
                Estaciones de Subte
              </div>
              <input v-model="verEstacionesSubte" class="check" type="checkbox" @change="checkEstacionesSubte()">
            </label>
          </div>
        </li>
        <li class="col-12 col-sm-6 col-md-12 px-2 px-md-0 d-flex align-items-center mb-1">
          <div :class="{ active: verEstablecimientosEducativos === true }"
            class="checkbox bg-white w-100 py-2 px-3 rounded shadow">
            <label class="d-flex align-items-center mb-0">
              <div class="p-sm font-AR f-14 w-100 d-flex align-items-center mb-0">
                Establecimientos <br class="d-none d-sm-block">Educativos
              </div>
              <input v-model="verEstablecimientosEducativos" class="check" type="checkbox"
                @change="checkEstablecimientosEducativos()">
            </label>
          </div>
        </li>
        <!--        <li class="col-12 col-sm-6 col-md-12 px-2 px-md-0 d-flex align-items-center mb-1">-->
        <!--          <div class="checkbox bg-white w-100 py-2 px-3 rounded shadow"-->
        <!--               :class="{active: verRecorridoColectivos===true}">-->
        <!--            <label class="d-flex align-items-center mb-0">-->
        <!--              <div class="p-sm font-SM w-100 d-flex align-items-center mb-0">-->
        <!--                Recorrido de <br class="d-none d-sm-block d-md-none">Colectivos-->
        <!--              </div>-->
        <!--              <input type="checkbox" class="check" v-model="verRecorridoColectivos" @change="checkRecorridoColectivos()"-->
        <!--                     hidden>-->
        <!--            </label>-->
        <!--          </div>-->
        <!--        </li>-->
      </ul>
    </div>
  </div>
</template>

<style></style>
<script>

import mapboxgl from "mapbox-gl";
import * as mapboxInit from '../mapbox';
import * as turf from '@turf/turf'

let map;
// let area;
// let coordenadas_neighborhood;
// let ciclovias;
// let estacionesSubte;
// let establecimientosEducativos;
let recorridoColectivos;
// let markerImage;

export default {
  name: "map-propiedad",
  props: ['neighborhood', 'mapData', 'ciclovias', 'estacionesSubte', 'establecimientosEducativos', 'recorrido-colectivos'],
  data() {
    return {
      accessToken: `${mapboxInit.API_KEY}`,
      verTransporte: false,
      verSustentabilidad: false,
      verCultura: false,
      verSalud: false,
      verFerias: false,
      verEstacionesSubte: false,
      verEstablecimientosEducativos: false,
      verRecorridoColectivos: false,
      subteMarkers: [],
      establecimientosMarkers: [],
    };
  },
  methods: {
    checkTransporte() {

      if (this.verTransporte) {
        map.addLayer({
          'id': 'ciclovias', 'type': 'line', 'source': 'ciclovias',
          'paint': { 'line-color': '#FF0000', 'line-width': 1, 'line-opacity': 0.55 }
        });
      } else {
        map.removeLayer('ciclovias');
      }
    },
    checkEstacionesSubte() {

      if (this.verEstacionesSubte)
        _.each(this.subteMarkers, (m) => { m.addTo(map) })
      else
        _.each(this.subteMarkers, (m) => { m.remove() })

    },
    checkEstablecimientosEducativos() {

      if (this.verEstablecimientosEducativos)
        _.each(this.establecimientosMarkers, (m) => { m.addTo(map) })
      else
        _.each(this.establecimientosMarkers, (m) => { m.remove() })

    },
    checkRecorridoColectivos() {
      _.each(recorridoColectivos, p => {
        p.setMap(this.verRecorridoColectivos ? map : null)
      })
    },
  },
  mounted() {

    mapboxgl.accessToken = this.accessToken;
    map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [this.mapData.center.lng, this.mapData.center.lat],
      zoom: 11.5,
      showZoom: true,
      attributionControl: false
    });
    const boundary = this.mapData.boundary;
    map.fitBounds([[boundary.west, boundary.north], [boundary.east, boundary.south]], { padding: 10 });

    map.addControl(new mapboxgl.ScaleControl());
    map.addControl(new mapboxgl.NavigationControl());


    const scope = this;
    map.on('load', () => {

      map.addSource('neighborhood_area', {
        'type': 'geojson',
        'data': {
          'type': 'Feature',
          'geometry': { 'type': 'Polygon', 'coordinates': scope.mapData.coords },
        }
      });

      map.addLayer({
        'id': 'neighborhood_area',
        'type': 'fill',
        'source': 'neighborhood_area',
        'paint': { 'fill-color': '#FF0000', 'fill-opacity': 0.2 }
      });

      //ciclovias
      map.addSource('ciclovias', {
        'type': 'geojson',
        'data': {
          'type': 'FeatureCollection',
          'features': [{
            'type': 'Feature',
            'geometry': {
              'type': 'MultiLineString',
              'coordinates': scope.ciclovias
            }
          }]
        }
      });

      //subtes
      this.subteMarkers = _(scope.estacionesSubte)
        .filter((e) => {
          return turf.booleanPointInPolygon(turf.point(e.coords), turf.polygon(scope.mapData.coords));
        })
        .map((e) => {
          return new mapboxgl.Marker({ scale: 0.8, })
            .setLngLat(e.coords);
        })
        .value();

      //Establecimientos educativos
      this.establecimientosMarkers = _(scope.establecimientosEducativos)
        .filter((e) => {
          return turf.booleanPointInPolygon(turf.point(e.coords), turf.polygon(scope.mapData.coords));
        })
        .map((e) => {
          return new mapboxgl.Marker({ scale: 0.8, })
            .setLngLat(e.coords);
        })
        .value();


    });
  }
};
</script>
<style>
#map {
  padding-top: 0px !important;
}
</style>
